// Monta o link wa.me a partir de um telefone em qualquer formato. Números só
// com DDD (10 ou 11 dígitos) recebem o código do Brasil (55). Retorna null
// quando não dá pra montar um número válido.
export const whatsappUrl = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');

  if (digits.length === 10 || digits.length === 11) {
    return `https://wa.me/55${digits}`;
  }
  if (digits.length >= 12 && digits.length <= 15) {
    return `https://wa.me/${digits}`;
  }
  return null;
};
